var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tooltip-container",class:[_vm.deviceWidthClass],attrs:{"role":"tooltip","tabindex":"-1"}},[(_vm.text)?_c('span',{staticClass:"tooltip",class:_vm.getClasses,attrs:{"tabindex":"-1","aria-hidden":"true"}},[_c('p',[_vm._v(_vm._s(_vm.text))])]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }